function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { useContext, useEffect, useState, useRef } from "react";
import { useLayoutEffect } from "../../../hooks/useLayoutEffect";
import { BreakpointsProvider, defaultBreakpoints, updatedDefaultBreakpoints } from "../BreakpointsProvider/index";
import { processPropertiesForState } from "../utils/breakpointsSize";
import { FlagsContext } from "../../FlagsProvider";
import { useTheme } from "../../ThemeProvider/useTheme";
var isEventAvailable = function() {
    return typeof window !== 'undefined' && !!window.addEventListener && !!window.removeEventListener;
};
export var Breakpoints = function(param) {
    var sProp = param.s, mProp = param.m, lProp = param.l, xlProp = param.xl, xxlProp = param.xxl, ssrSize = param.ssrSize, children = param.children;
    var hasExecuted = useRef(false);
    var ref;
    var breakpointUpdates = ((ref = useContext(FlagsContext)) !== null && ref !== void 0 ? ref : {}).breakpointUpdates;
    var themeBreakpoints = useTheme().breakpoint;
    var ref1 = breakpointUpdates ? themeBreakpoints !== null && themeBreakpoints !== void 0 ? themeBreakpoints : {} : defaultBreakpoints, sTheme = ref1.s, mTheme = ref1.m, lTheme = ref1.l, xlTheme = ref1.xl, xxlTheme = ref1.xxl;
    var ref2 = breakpointUpdates ? updatedDefaultBreakpoints : defaultBreakpoints, sDefault = ref2.s, mDefault = ref2.m, lDefault = ref2.l, xlDefault = ref2.xl, xxlDefault = ref2.xxl;
    var ref3;
    var s = (ref3 = sProp !== null && sProp !== void 0 ? sProp : sTheme) !== null && ref3 !== void 0 ? ref3 : sDefault;
    var ref4;
    var m = (ref4 = mProp !== null && mProp !== void 0 ? mProp : mTheme) !== null && ref4 !== void 0 ? ref4 : mDefault;
    var ref5;
    var l = (ref5 = lProp !== null && lProp !== void 0 ? lProp : lTheme) !== null && ref5 !== void 0 ? ref5 : lDefault;
    var ref6;
    var xl = (ref6 = xlProp !== null && xlProp !== void 0 ? xlProp : xlTheme) !== null && ref6 !== void 0 ? ref6 : xlDefault;
    var ref7;
    var xxl = (ref7 = xxlProp !== null && xxlProp !== void 0 ? xxlProp : xxlTheme) !== null && ref7 !== void 0 ? ref7 : xxlDefault;
    var ref8 = _slicedToArray(useState(_objectSpread({
        s: Math.floor(s),
        m: Math.floor(m),
        l: Math.floor(l),
        xl: Math.floor(xl)
    }, xxl ? {
        xxl: Math.floor(xxl)
    } : undefined, ssrSize ? {
        ssrSize: ssrSize
    } : undefined)), 2), state = ref8[0], setState = ref8[1];
    useEffect(function() {
        setState(function(previousState) {
            return _objectSpread({}, previousState, processPropertiesForState(_objectSpread({}, previousState, {
                s: Math.floor(s),
                m: Math.floor(m),
                l: Math.floor(l),
                xl: Math.floor(xl)
            }, xxl ? {
                xxl: Math.floor(xxl)
            } : undefined, ssrSize ? {
                ssrSize: ssrSize
            } : undefined)));
        });
    }, [
        s,
        m,
        l,
        xl,
        xxl,
        ssrSize
    ]);
    useLayoutEffect(function() {
        if (!hasExecuted.current) {
            setState(function(previousState) {
                return _objectSpread({}, previousState, processPropertiesForState(previousState));
            });
        }
        hasExecuted.current = true;
    }, []);
    useLayoutEffect(function() {
        var listenerCallback = function() {
            return setState(function(previousState) {
                return _objectSpread({}, previousState, processPropertiesForState(previousState));
            });
        };
        if (isEventAvailable()) {
            window.addEventListener('resize', listenerCallback);
        }
        return function() {
            if (isEventAvailable()) {
                window.removeEventListener('resize', listenerCallback);
            }
        };
    }, []);
    return _jsx(BreakpointsProvider, {
        value: state,
        children: children
    });
};
export default Breakpoints;
